import {EventHostLiabilityLayout} from "@/components/offer/EventHostLiabilityLayout";
import {MultiDecisionLayout} from "@/components/offer/MultiDecisionLayout";
import {ApiResponseV2, ProductQuotes} from "@vertical-insure/shared";
import {ProductCardCheckboxList} from "@/components/ui/ProductCardCheckboxList";
import {ProductCardRadio} from "@/components/ui/ProductCardRadio";
import { PetLayout } from "./offer/PetLayout";

export const ProductComponent = ({product, productQuotes}:{product: string, productQuotes: ProductQuotes}) => {
  if (product === 'event-host-liability') {
    return <EventHostLiabilityLayout quote={productQuotes[0]}  />
  } else if (product === 'travel') {
    return <MultiDecisionLayout quote={productQuotes[0] as ApiResponseV2}  />
  } else if (product === 'pet') {
    return <PetLayout quote={productQuotes[0] as ApiResponseV2}  />
  } else if (productQuotes.length > 1) {
    return <ProductCardCheckboxList product={product}  />
  } else {
    return <ProductCardRadio product={product} quote={productQuotes[0]}/>
  }
}